var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("modal-key-container", {
    attrs: {
      title: "Copiar chave",
      "show-button-close": false,
      "not-close": _vm.isDisabled,
    },
    on: { handleClose: () => _vm.$emit("handleClose") },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("emd-text", { attrs: { size: "regular" } }, [
              _vm._v(" " + _vm._s(_vm.$t("description.begin")) + " "),
              _c("b", [_vm._v(_vm._s(_vm.$t("description.highlight")))]),
              _vm._v(" " + _vm._s(_vm.$t("description.end")) + " "),
            ]),
            _c("copy-clipboard", {
              attrs: { copiable: _vm.secretKey },
              on: { handleCopied: _vm.handleCopied },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c(
              "emd-button",
              {
                attrs: {
                  color: "primary",
                  type: "outline",
                  "data-testid": "confirm-action",
                },
                on: { click: _vm.handleClick },
              },
              [_vm._v(" " + _vm._s(_vm.$t(_vm.labelCopy)) + " ")]
            ),
            _c(
              "emd-button",
              {
                attrs: {
                  color: "primary",
                  "data-testid": "confirm-action",
                  disabled: _vm.isDisabled,
                },
                on: { click: _vm.handleClose },
              },
              [_vm._v(" " + _vm._s(_vm.$t("form.button.ok")) + " ")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }